module.exports = __webpack_public_path__ + "static/media/WheatStage111.b8806291.PNG";